import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { fuseAnimations } from '@fuse/animations';
import * as $ from 'jquery';

import { SurveyStatusV2Service } from "../survey-status-v2.service";

interface producto {
  name: string;
  id?: number;
  category?: string;
  anioProducto?: string;
  datosProducto?: any;
  acumulable?: boolean;
  consecutivo?: boolean;
  children?: producto[];
}

interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  id?: number;
  category?: string;
  anioProducto?: string;
  acumulable?: boolean;
  consecutivo?: boolean;
  datosProducto?: any;
}

@Component({
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations   : fuseAnimations
})
export class MenuComponent implements OnInit {

  @Input() brokerEmpresa: Observable<any>;

  @Output() cierraMenu: EventEmitter<any> = new EventEmitter();
  @Output() enviaProducto: EventEmitter<any> = new EventEmitter();
  @Output() cargaPrevio: EventEmitter<any> = new EventEmitter();

  private _transformer = (node: producto, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      id: node.id,
      category: node.category,
      anioProducto: node.anioProducto,
      acumulable: node.acumulable,
      consecutivo: node.consecutivo,
      datosProducto: node.datosProducto,
    };
  }
  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  cargando = true;
  idEmpresa: string;
  fechasProrrogasRegis: any;
  idProductoPrevio: string = "";
  productosEmpresa = [
    {
      name: 'Fruit',
      children: [
        {name: 'Apple'},
        {name: 'Banana'},
        {name: 'Fruit loops'},
      ]
    }, {
      name: 'Vegetables',
      children: [
        {
          name: 'Green',
          children: [
            {name: 'Broccoli'},
            {name: 'Brussel sprouts'},
          ]
        }, {
          name: 'Orange',
          children: [
            {name: 'Pumpkins'},
            {name: 'Carrots'},
          ]
        },
      ]
    },
  ];

  constructor(
    private activatedRoute : ActivatedRoute,
    private surveyServ: SurveyStatusV2Service
  ) {
    // this.dataSource.data = this.productosEmpresa;
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
    });
  }


  ngOnInit() {
    this.brokerEmpresa.subscribe((datos:any) => { //recibe el broker de la empresa
      this.getProductos(datos);
    });
    if(localStorage.getItem('productoID')){
      // console.log("entro condicion");

      this.cargaPrevio.emit({status:true});
      this.idProductoPrevio = localStorage.getItem('productoID');
    }
  }

  getProductos(broker:number){
    this.surveyServ.getProductos(this.idEmpresa).subscribe((respuesta:any) => {
      console.log("getProductos:",respuesta);
      //arreglo de productos certificar
      let arregloCertificar: any = {
        name: 'certificar',
        children: [
          { name: 'v1', id: 1, category: 'certificar', children: [] },
          { name: 'v2', id: 20, category: 'certificar', children: [] },
          { name: 'v3', id: 40, category: 'certificar', children: [] },
          { name: 'v3GG', id: 75, category: 'certificar', children: [] },
          // { name: 'swift', id: 68, category: 'certificar', children: [] },
        ]
      };
      let arregloCertificarAMCO: any = {
        name: 'certificacionesAdicio',
        children: [
          { name: 'v1Amco', id: 56, category: 'certificacionesAdicio', children: [] },
          { name: 'v2TD', id: 57, category: 'certificacionesAdicio', children: [] },
          { name: 'v3PE', id: 58, category: 'certificacionesAdicio', children: [] },
        ]
      };
      respuesta.productosCertificar.forEach(producto => {
        let idxTipo = arregloCertificar.children.findIndex(item => item.id == producto.idProducto);
        if(idxTipo != -1){
          arregloCertificar.children[idxTipo].children.push({
            name: 'certificar',
            anioProducto: producto.fechaCertificar,
            datosProducto: producto
          });
        }
      });

      respuesta.productosCertificar.forEach(producto => {
        let idxTipo = arregloCertificarAMCO.children.findIndex(item => item.id == producto.idProducto);
        if(idxTipo != -1){
          arregloCertificarAMCO.children[idxTipo].children.push({
            name: 'certificacionesAdicio',
            anioProducto: producto.fechaCertificar,
            datosProducto: producto
          });
        }
      });
      //arreglo de productos medir
      let arregloMedir: any = {
        name: 'medir',
        children: [
          { name: 'v1', id: 2, category: 'medir', tipo: 0, children: [] },
          { name: 'v2', id: 11, category: 'medir', tipo: 1, children: [] },
          { name: 'v3', id: 12, category: 'medir', tipo: 2, children: [] },
          { name: 'v4', id: 13, category: 'medir', tipo: 3, children: [] },
          { name: 'v5', id: 14, category: 'medir', tipo: 4, children: [] },
          { name: 'v6', id: 15, category: 'medir', tipo: 5, children: [] },
          { name: 'v7', id: 16, category: 'medir', tipo: 6, children: [] },
          { name: 'v8', id: 41, category: 'medir', tipo: 0, children: [] },
        ]
      };
      //CONDICION SI EL INSTITUTO DE LA EMPRESA ES AMCO
      if(broker == 18){
        arregloMedir = {
          name: 'medir_amco',
          children: [
            { name: 'v1', id: 41, category: 'medir_amco', tipo: 0, children: [] },
          ]
        };
      }
      respuesta.productosCertificar.forEach(producto => {
        let idxTipo = arregloMedir.children.findIndex(item => item.id == producto.idProducto);
        if(idxTipo != -1){
          arregloMedir.children[idxTipo].children.push({
            name: 'medir_3',
            anioProducto: producto.fechaCertificar,
            datosProducto: producto
          });
        }
      });
      respuesta.productosMedir.forEach(producto => {
        //se agrega el id producto a cada producto porque no lo trae
        producto.tipoProducto = arregloMedir.children[0].id;
        arregloMedir.children[0].children.push({
          name: 'medir_1',
          anioProducto: producto.fechaMedir,
          datosProducto: producto
        });
      });
      respuesta.productosMedir2.forEach(producto => {
        let idxTipo = arregloMedir.children.findIndex(item => item.tipo == producto.tipo);
        if(idxTipo != -1){
          //se agrega el id producto a cada producto porque no lo trae
          producto.tipoProducto = arregloMedir.children[idxTipo].id;
          arregloMedir.children[idxTipo].children.push({
            name: 'medir_2',
            anioProducto: producto.fechaProducto,
            datosProducto: producto
          });
        }
      });
      //arreglo de productos pulse
      let arregloPulse: any = {
        name: 'pulse',
        children: [
          { name: 'v1', id: 4, category: 'pulse', children: [] },
          { name: 'v2', id: 42, category: 'pulse', children: [] },
        ]
      };
      respuesta.productosCertificar.forEach(producto => {
        let idxTipo = arregloPulse.children.findIndex(item => item.id == producto.idProducto);
        if(idxTipo != -1){
          arregloPulse.children[idxTipo].children.push({
            name: 'pulse_3',
            anioProducto: producto.fechaCertificar,
            acumulable: true,
            consecutivo: true,
            datosProducto: producto
          });
        }
      });

      respuesta.productosPulseCheck.forEach(producto => {
        arregloPulse.children[0].children.push({
          name: 'pulse_1',
          anioProducto: producto.fechaPulseCheck,
          datosProducto: producto
        });
      });

      arregloPulse.children.forEach(tipoProd => {
        let arregloAniosPulse: any = [];
        tipoProd.children.forEach(prodIndiv => {
          let arbolAnio = arregloAniosPulse.find(item => item.name == prodIndiv.anioProducto);
          if(arbolAnio == undefined){
            arregloAniosPulse.push({
              name: prodIndiv.anioProducto.toString(),
              children: [prodIndiv],
              acumulable: true
            });
          } else{
            arbolAnio.children.push(prodIndiv);
          }
        });
        tipoProd.children = arregloAniosPulse;
      });

      //arreglo de productos focus
      let arregloFocus: any = {
        name: 'focus',
        children: [
          // { name: 'v1', id: 43, children: [] },
        ]
      };

      respuesta.productosCertificar.forEach(producto => {
        if(producto.idProducto == 43){
          arregloFocus.children.push({
            name: 'focus',
            anioProducto: producto.fechaCertificar,
            acumulable: true,
            datosProducto: producto
          });
        }
      });
      let arregloAniosFocus: any = [];
      arregloFocus.children.forEach(tipoProd => {
        // tipoProd.children.forEach(prodIndiv => {
          let arbolAnio = arregloAniosFocus.find(item => item.name == tipoProd.anioProducto);
          if(arbolAnio == undefined){
            arregloAniosFocus.push({
              name: tipoProd.anioProducto.toString(),
              children: [tipoProd],
              acumulable: true
            });
          } else{
            arbolAnio.children.push(tipoProd);
          }
        // });
      });
      arregloAniosFocus.forEach(arrAnio => {
        arrAnio.children.sort( (a,b) => {
          if(a.datosProducto.numPulse > b.datosProducto.numPulse){ return 1; } else{ return -1; }
        });
      });
      // tipoProd.children = arregloAniosFocus;
      arregloFocus.children = arregloAniosFocus;

      //arreglo de productos nom35
      // let arregloNOM35: any = {
      //   name: 'nom35',
      //   children: []
      // };
      // respuesta.productosNorma35.forEach(producto => {
      //   arregloNOM35.children.push({
      //     name: 'nom35',
      //     anioProducto: producto.fechaNorma35,
      //     datosProducto: producto
      //   });
      // });

      let arregloNOM35: any = {
        name: 'nom35',
        children: [
          { name: 'v1', id: 3, category: 'nom35', children: [] },
          { name: 'v2', id: 63, category: 'nom35', children: [] },
        ]
      };
      respuesta.productosNorma35.forEach(producto => {
        let idxTipo = arregloNOM35.children.findIndex(item => item.id == producto.idProducto);
        if(idxTipo != -1){
          arregloNOM35.children[idxTipo].children.push({
            name: 'nom35',
            anioProducto: producto.fechaNorma35,
            datosProducto: producto
          });
        }
      });



      //arreglo de productos cgo express
      let arregloCGOX: any = {
        name: 'cgoExpress',
        children: []
      };
      respuesta.productosCGOExpress.forEach(producto => {
        arregloCGOX.children.push({
          name: 'cgoExpress',
          anioProducto: producto.date,
          datosProducto: producto
        });
      });
      arregloCGOX.children.sort( (a,b) => {
        if(a.datosProducto.date > b.datosProducto.date){ return 1; } else{ return -1; }
      });

      let arregloResultadosGoFlow: any = {
        name: 'resulGoFlow',
        children: [],
      };

      respuesta.productosCertificar.forEach(producto => {
        if (producto.idProducto==70) {
          arregloResultadosGoFlow.children.push({
            name: 'resulGoFlow',
            anioProducto: producto.fechaCertificar,
            datosProducto: producto
          });
        }
      });

      arregloResultadosGoFlow.children.sort( (a,b) => {
        if(a.datosProducto.fecha > b.datosProducto.fecha){ return 1; } else{ return -1; }
      });

      //// arreglo productos swift
      let arregloProductosSwift: any = {
        name: 'swift',
        children: [],
      };

      respuesta.productosCertificar.forEach(producto => {
        if (producto.idProducto == 68) {
          arregloProductosSwift.children.push({
            name: 'swift',
            anioProducto: producto.fechaCertificar,
            datosProducto: producto
          });
        }
      });

      arregloProductosSwift.children.sort( (a,b) => {
        if(a.datosProducto.fecha > b.datosProducto.fecha){ return 1; } else{ return -1; }
      });

      let arbolProductos = [arregloCertificar,arregloMedir,arregloPulse,arregloFocus,arregloNOM35,arregloCGOX,arregloCertificarAMCO,arregloResultadosGoFlow, arregloProductosSwift];
      // console.log("arbol:",arbolProductos);
      let arbolDepurado = this.depuraArregloProducto(JSON.parse(JSON.stringify(arbolProductos)));
      // console.log("depurado:",arbolDepurado);

      this.dataSource.data = arbolDepurado;
      this.cargando = false;
      this.vistaProductoPrevio();
      this.expandAllTree();
    });
  }

  depuraArregloProducto(arreglo:any){
    let arregloDepurado: any = [];
    arreglo.forEach((tipoProd,i) => {
      if(tipoProd.hasOwnProperty('children')){
        if(tipoProd.children.length > 0){
          tipoProd.children = this.depuraArregloProducto(tipoProd.children);
          if(tipoProd.children.length > 0){
            arregloDepurado.push(tipoProd);
          }
        }
      } else if(tipoProd.hasOwnProperty('datosProducto')){
        arregloDepurado.push(tipoProd);
      }
    });
    return arregloDepurado;
  }

  vistaProductoPrevio(){
    let datosArbol = this.dataSource.data;
    // console.log("datosArbol:",datosArbol);
    this.buscaProductoRecursivo(datosArbol);
  }
  buscaProductoRecursivo(arreglo:any){
    if(Array.isArray(arreglo)){
    // if(arreglo.children != undefined){
      arreglo.forEach(elemento => {
        if(elemento.children != undefined){
          this.buscaProductoRecursivo(elemento.children);
        } else{
          let idProductoActual = this.obtieneIdProductoCorrecto(elemento.datosProducto);
          if(idProductoActual == this.idProductoPrevio){
            // console.log("producto coincidente encontrado:",elemento.datosProducto);
            this.eligeProducto(elemento.datosProducto, true);
            return;
          }
        }
      });
    }
  }



  obtieneIdProductoCorrecto(productoActual: any){
    let idProductoActual = productoActual.idCertificar != undefined ? productoActual.idCertificar : undefined;
    if(idProductoActual == undefined){
      idProductoActual = productoActual.idMedir != undefined ? productoActual.idMedir : undefined;
      if(idProductoActual == undefined){
        idProductoActual = productoActual.idPulseCheck != undefined ? productoActual.idPulseCheck : undefined;
        if(idProductoActual == undefined){
          idProductoActual = productoActual.idNorma35 != undefined ? productoActual.idNorma35 : undefined;
          if(idProductoActual == undefined){
            idProductoActual = productoActual._id != undefined ? productoActual._id : productoActual.idProducto;
          }
        }
      }
    }
    return idProductoActual;
  }

  eligeProducto(producto:any, bypass?:boolean){
    // console.log("productoElegido:",producto);
    this.idProductoPrevio = this.obtieneIdProductoCorrecto(producto);
    switch (producto.idProducto) {
      case 1: case 20: case 40: case 41: case 42: case 43: case 56: case 57: case 58:
      this.getProrrogasFechasCierre(this.obtieneIdProductoCorrecto(producto));

        break;

      default:
      if (localStorage.getItem("ProrrogasAgregadas")) {
        localStorage.removeItem("ProrrogasAgregadas");
      }
      // console.log("no hace nada de get prorrogas");

        break;
    }
    this.enviaProducto.emit(producto);
    if(!bypass){
      this.cerrar();
    }
  }

  cerrar(){
    this.cierraMenu.emit(true);
  }

  expandAllTree(){

  //this.treeControl.expand(this.treeControl.dataNodes[index]);

  this.treeControl.expandAll();
  }

  getProrrogasFechasCierre(datos){
        this.surveyServ.getProrrogasFechaCierre(datos).subscribe( (data: any) => {
          console.log("getProrrogasFechaCierre:",data);
            this.fechasProrrogasRegis=data.result;
            if (this.fechasProrrogasRegis.length>0) {
              localStorage.setItem("ProrrogasAgregadas", JSON.stringify(data.result));
            }else{
              localStorage.setItem("ProrrogasAgregadas", JSON.stringify([]));

            }

  });
}

}
